module.exports = __webpack_public_path__ + "static/media/Mitsubachi Notebooks.5b9695cc.jpg";